module.exports = __webpack_public_path__ + "static/media/face8.16958c47.jpg";